import type { FeedbackSummary, FeedbackWidget } from './types';
import type { FeedbackSummaryDto } from './dto';

export function mapFeedbackSummaryResponseDtoToModel(
  feedbackWidgetsData: FeedbackSummaryDto[],
): FeedbackSummary {
  // seems like endpoint returns widgets with id as null and any other attribute set
  const filteredWidgetsData = feedbackWidgetsData.filter((widget) => widget.widget_id !== null);
  const activeWidgets = filteredWidgetsData.reduce((widgets: FeedbackWidget[], widget) => {
    return [
      ...widgets,
      ...(widget.enabled
        ? [
            {
              id: widget.widget_id,
              name: widget.name,
              responseCount: widget.response_count,
              emotionStyle: widget.emotion_style,
              sentiment: widget.sentiment,
            },
          ]
        : []),
    ];
  }, []);

  return {
    activeWidgets,
    hasDisabledWidgetsOnly: filteredWidgetsData.length > 0 && activeWidgets.length === 0,
  };
}
